import { ClientBranding } from '@brands/services/identity/types/UserProfile';

import { RootState } from '../store';

export const selectClientBranding = (state: RootState): ClientBranding | null =>
  state.clientBranding.clientBranding;
